import type { Set } from '../types/Set'
import SetCard from './SetCard'

type Props = {
  sets: Set[]
  onSelect?: (set: Set) => void
}

export default function SetList({ sets, onSelect }: Props) {
  if (!sets.length) return <p>No sets found.</p>

  return (
    <section className="set-list">
      {sets.map((s) => (
        <SetCard key={s.id} set={s} onSelect={onSelect} />
      ))}
    </section>
  )
}
